import "preact/debug";
import categoryStyles from "./category.module.css";
import eventStyles from "./event.module.css";

export function Categories({ link }) {
  return (
    <div
      class={`${categoryStyles["list-wrapper"]} ${
        link.megaMenu.popularEvents.length > 0
          ? categoryStyles["list-wrapper--two-columns"]
          : ""
      } mb-3`}
    >
      {link.megaMenu.categories.length > 0 && (
        <div>
          <h3 class={`${categoryStyles["heading"]} mb-2`}>
            {globalThis.translations.categories || "Categories"}
          </h3>
          <ul
            class={`${categoryStyles["list"]} ${
              link.megaMenu.popularEvents.length === 0
                ? categoryStyles["list--two-columns"]
                : ""
            }`}
          >
            {link.megaMenu.categories.map((category) => (
              <li class={categoryStyles["list__item"]}>
                <a href={category.url}>{category.name}</a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {link.megaMenu.popularEvents.length > 0 && (
        <div>
          <h3 class={`${eventStyles["heading"]} mt-2 mt-lg-0`}>
            {globalThis.translations.popularEvents || "Popular Events"}
          </h3>
          <ul>
            {link.megaMenu.popularEvents.map((popularEvent) => (
              <li>
                <a
                  href={popularEvent.url}
                  class={`${eventStyles["link"]} mt-2`}
                >
                  <img
                    src={popularEvent.image.url}
                    alt={popularEvent.image.alt}
                    class={`${eventStyles["image"]}`}
                  />
                  {popularEvent.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {link.children.length > 0 && (
        <div>
          <h3 class={`${eventStyles["heading"]} mt-2 mt-lg-0`}>
            {globalThis.translations.about || "About"}
          </h3>
          <ul>
            {link.children.map((child) => (
              <li>
                <a
                  href={child.url}
                  class={`${eventStyles["link"]} mt-2`}
                >
                  {child.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
